import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL || window.location.origin;

const apiClient = axios.create({
  baseURL: apiUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default apiClient;
